// src/components/SignIn.tsx
import React, { useState, useEffect } from 'react';
import { useAuth } from '../AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';
import { useNotifications } from '../NotificationContext';
import { BASE_URI } from '../Config';

const PasswordReset: React.FC = () => {
    const navigate = useNavigate(); // Initialize the hook

    const [password, setPassword] = useState("");    
    const [password_repeat, setPasswordRepeat] = useState("");

    const location = useLocation();
    const { pushMessage } = useNotifications();

    const getSecretFromUrl = (): string | null => {
        const params = new URLSearchParams(location.search);
        return params.get('code');
    }

    const getEmailFromUrl = (): string | null => {
        const params = new URLSearchParams(location.search);
        return params.get('email');
    }
    // console.log(userRole);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        // For now, we'll just log the user data. You can add API calls or other logic here later.

        const code = getSecretFromUrl();
        const email = getEmailFromUrl();
        if (!code || !email) {
            pushMessage({text: "Missing information, please recheck your link", type: "error"})
            return;
        }

        if (password !== password_repeat){
            pushMessage({text:"Passwords do not match", type: "error"})
            return;
        }

        const userData = { email, new_password: password, code };

        try {
            const response = await fetch(`${BASE_URI}/password_reset`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(userData)
            });

            const data = await response.json();

            if (data.success) {
                console.log("Signup successful!");
                pushMessage({text: "Password reset successfully", type: "notification"})
                navigate("/signin") // This will probably be email verifcation page??
                // Redirect or perform other actions after successful signup
            } else {
                console.log("Signup failed!");
                pushMessage({text: "Something went wrong resetting password", type: "error"})
            }
        } catch (error) {
            console.error("There was an error during signup:", error);
            pushMessage({text: "Something went wrong resetting password", type: "error"})
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <h3>Password reset</h3>
            <div>
                <label>Password: </label>
                <input type="password" value={password} onChange={e => setPassword(e.target.value)} />
                <input type="password" value={password_repeat} onChange={e => setPasswordRepeat(e.target.value)} />
            </div>
            <input type="submit" value="Reset"></input>
        </form>
    );
}

export default PasswordReset;
